import {
  _sharedActionsConstantsSettings,
  _sharedActionsSettings
} from "@/shared/store/settings/actions";

export const settingsActionsConstants = _sharedActionsConstantsSettings;
export const settingsActions = _sharedActionsSettings;
